import { ListChecks, ShieldCheck } from "lucide-react";
import { FieldworkRow } from "../../../../hooks/useFieldworkRows";

/**
 * The Type cell. Icons deliberately match AuditSidebar's Controls (ShieldCheck)
 * and Work Steps (ListChecks) links, so the column reads as the same taxonomy
 * the sidebar already teaches.
 */
export function FieldworkTypeCell({ type }: { type: FieldworkRow["type"] }) {
  const isControl = type === "control";
  const Icon = isControl ? ShieldCheck : ListChecks;

  return (
    <div className="flex items-center gap-2 text-stone-700">
      <Icon size={16} className="shrink-0 text-stone-500" />
      <span className="truncate">{isControl ? "Control" : "Work Step"}</span>
    </div>
  );
}
